import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "cypher",
  extensions: [".cypher", ".cyp"],
  aliases: ["Cypher", "OpenCypher"],
  loader: () => import('./cypher.js')
});
